<template>
  <div class="vue-ui-buttons">
    <div>
      <div
        v-for="(i, j) in [1, 2, 3]"
        :data-vue-ui-button-id="i"
        :style="{
          backgroundImage: `url('${Icon}')`,
          backgroundPosition: `0 -${map[j]}px`
        }"
      />
    </div>
    <div class="vue-ui-buttons-hover">
      <div
        v-for="(i, j) in [1, 2, 3]"
        :data-vue-ui-button-id="i"
        :data-active="active === j"
        @click="$emit('view-select', i); active = j"
        :style="{
          backgroundImage: `url('${Icon}')`,
          backgroundPosition: `-26px -${map[j]}px`
        }"
      />
    </div>
  </div>
</template>

<script>
  import Icon from 'Assets/images/icons.png';
  import EventSystem from '../utils/EventSystem';

  export default {
    data() {
      return {
        Icon,
        map: [0, 22, 45],
        active: 0,
      }
    },
    created() {
      EventSystem.$on('view-change', n => {
        this.active = n - 1;
      });
      EventSystem.$on('area-changed', n => {
        this.active = 0;
      });
    }
  };
</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/buttons.vue